// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AddAdvanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/add_advance
 *
 * Validates input for creating a single payroll advance.
 */
import { registerContract } from './validate'

export interface Payroll_AddAdvanceInput {
period_id: number
recebimento_id: number
franchise_id: number
notes?: string
}

registerContract('Payroll_AddAdvanceInput', {
  period_id:      { type: 'number',  required: true },
  recebimento_id: { type: 'number',  required: true },
  franchise_id:   { type: 'number',  required: true },
  notes:          { type: 'string',  required: false },
})
